import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  // Check if the user is authenticated
  const isAuthenticated = !!localStorage.getItem('userId'); // For example, using userId in localStorage

  return isAuthenticated ? children : <Navigate to="/sign-in" />;
};

export default PrivateRoute;
